import React from 'react';
import { Navigate } from "react-router-dom";

const Logout = () => {

    // Clear the token from local storage
    localStorage.clear();

    // Redirect to the login page
    return <Navigate to="/" />;

}

export default Logout;
